import Vue from 'vue'

Vue.filter('currency', value => {
    if (value === null) {
        return null;
    }
    let formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

Vue.filter('year', (value) => {
    if (!value) {
        return null;
    }
    return new Date(value).getFullYear();
});

Vue.filter('local_date', value => {
    if (!value) {
        return null
    }
    return moment.utc(value).local().format('DD/MM/YYYY')
});

Vue.filter('local_datetime', value => {
    if (!value) {
        return null
    }
    return moment.utc(value).local().format('DD/MM/YYYY hh:mm a')
});

Vue.filter('relative', value => {
    if (!value) {
        return null
    }
    return moment.utc(value).local().fromNow();
});

Vue.filter('local_number', value => {
    if (!value) {
        return null
    }
    return Number(value).toLocaleString();
});
